import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ComingSoonStatus } from '../../../shared/components/coming-soon-status/coming-soon-status';

@Component({
    standalone: true,
    imports: [
        ComingSoonStatus,
    ],
    templateUrl: './regions.html',
    styleUrl: './regions.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class Regions {}
